export const LOCAL_STORAGE_KEYS = {
  IS_ORGANIC_USER: 'isOrganicUser',
  EMAIL: 'email',
  ORDER_ID: 'orderId',
  SUCCESS_PAGE_TYPE: 'successPageType',
  LAST_EDIT_FILE_ID: 'lastEditFileId',
  USED_FREE_FILE: 'usedFreeFile',
  SPECIAL_OFFER_ALREADY_USED_POPUP: 'special-offer-already-used-popup',
  SPECIAL_OFFER_POPUP: 'special-offer-popup',
  DATA_TO_CONVERT: 'dataToConvert',
  DATA_TO_EVENT: 'dataToEvent',
  DATA_TO_EDIT: 'dataToEdit',
  PRINT_DOCUMENT: 'printDocument',
  SEND_EMAIL: 'sendEmail',
  COMPRESSED_SIZE: 'compressedSize',
  SEND_FILE_VIA_EMAIL_PAYLOAD: 'sendFileViaEmailPayload',
  TRIAL_DURATION: 'trialDuration',
  SELECTED_PLAN: 'selectedPlan',
  FILE_TO_PRINT: 'fileToPrint',
  FILE_ID_TO_SEND: 'fileIdToSend',
  FILE_TO_SEND: 'fileToSend',
  AB_TESTS: 'abTests',
  USER_COUNTRY: 'userCountry',
  OUTPUT_LANG: 'outputLang',
  SOURCE_LANG: 'sourceLang',
  FILE_ID: 'fileId',
  EXPORT_FILES_COUNT: 'exportFilesCount',
  MERGED_FILES_COUNT: 'mergedFilesCount',
  DETECTED_LANG_FOR_TRANSLATE: 'detectedLangForTranslate',
  HAS_DOWNLOADED_FILE: 'hasDownloadedFile',
  IS_AUTO_TEST: 'isAutoTest',
  IS_MOBILE: 'isMobile',
  DOWNLOAD_FROM_DASHBOARD: 'downloadFromDashboard',
  APPENDED_AB_TESTS: 'appendedAbTests',
  TEST_KEY: '_test_local_storage_',
  COOKIE_CLOSED: 'cookieClosed',
  PREV_PATH: 'prevPath',
  MARKETING_VALUES: 'marketing',
  USER_META: 'meta',
  IS_USER_META_STORED: 'metaStored',
  READY_FILE_FORMAT: 'readyFileFormat',
  SERVICE: 'service',
  DATA_MULTIPLE_TO_CONVERT: 'dataMultipleToConvert',
  RELATION_EMAIL: 'relationEmail',
  QUERY_AFFILIATE: 'queryAffiliate',
  RELATION_TOKEN: 'relationToken',
  SHOW_RATE: 'showRate',
  IS_NOT_PAYPAL: 'isNotPaypal',
  FILE_ID_KEY: 'fileId',
  HAS_SEEN_UPSALE: 'hasSeenUpsale',
  IS_UPSELL_PURCHASE_SUCCESS: 'isUpsalePurchaseSuccess'
} as const;
